import React, { useRef, useState } from 'react'
import Modal from "../../../../components/Modal";
import useOutsideClick from "../../../../hooks/useOutsideClick";
import {observer} from "mobx-react";
import './SaleModal.sass'
import {useResize} from "../../../../hooks/useResize";

const SaleModal = observer(

    (props) => {
        const myRef = useRef()
        const windowSize = useResize()
        const [visibility, setVisibility] = useState(props.visibility)

      useOutsideClick(myRef, ()=>{setVisibility(false)})
        if (visibility) return (
          <Modal>
            <img ref={myRef} src={windowSize.width < 1100 ? './saleMobile.png' : './sale.png'} alt='sale' />
          </Modal>
        )
      return ''

    }

)
export default SaleModal;